import { hasMegaMenu } from './descriptor.has-megamenu.js';
import { shouldTerminateMegaMenu } from './descriptor.should-terminate-megamenu.js';
import { findPageDescriptorById } from './util.find-page-descriptor-by-id.js';

function isPartOfMegaMenu(state, pageDescriptor) {
  if (pageDescriptor && shouldTerminateMegaMenu(pageDescriptor)) {
    return false;
  }
  if (pageDescriptor == null ? void 0 : pageDescriptor.parentId) {
    const parentDescriptor = findPageDescriptorById(
      state,
      pageDescriptor.parentId
    );
    return isPartOfMegaMenu(state, parentDescriptor);
  }
  return hasMegaMenu(pageDescriptor);
}

export { isPartOfMegaMenu };
//# sourceMappingURL=descriptor.is-part-of-megamenu.js.map
